export default [
  {
    path: '/ci/all',
    name: 'ci_all',
    component: () => import('./AllCi.vue'),
    meta: {
      name: 'CI - Todas',
      auth: true,
      user: 'Admin',
    },
  },
]
